<template>
  <div
    class="delivery-page"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <template v-if="!homeLoading && docData.processCoopDeliveryId">
      <finishAdd
        v-if="docData.statusCheck == 0"
        :key="'edit-' + docData.processCoopDeliveryId"
        :itemList="detailList"
        :finish_type="1"
        @backOrderState="getList"
        @backHome="backHome"
      />

      <template v-else>
        <div class="page-header">
          <div class="page-header__left">
            <h2 class="page-header__title">工序委外发货单详情</h2>
          </div>
          <div class="page-header__actions">
            <el-button size="small" plain @click="backHome">返回</el-button>
            <el-button
              v-if="showOutWarehouseButton"
              size="small"
              type="primary"
              :loading="outWarehouseLoading"
              @click="handleOutWarehouse"
            >出库</el-button>
            <el-button
              v-if="showCancelOutWarehouseButton"
              size="small"
              type="warning"
              plain
              :loading="cancelOutWarehouseLoading"
              @click="handleCancelOutWarehouse"
            >撤销出库</el-button>
            <el-button
              v-if="showCancelAuditButton"
              size="small"
              type="info"
              :loading="cancelAuditLoading"
              @click="handleCancelAudit"
            >取消审核</el-button>
          </div>
        </div>

        <div class="delivery-card">
          <div class="delivery-card__head">
            <div class="delivery-card__head-left">
              <span class="delivery-card__label">发货单</span>
              <span class="delivery-card__title">{{
                docData.processCoopDeliveryNumber || "工序委外发货单"
              }}</span>
            </div>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <label>工序委外订单号</label>
              <span>{{ docData.baseProcessOutsourcingDocNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>发货单号</label>
              <span>{{ docData.processCoopDeliveryNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>预计到货日期</label>
              <span>{{ displayExpectedDate }}</span>
            </div>
            <div class="info-item">
              <label>物流公司</label>
              <span>{{ docData.baseLogisticsCompany || "--" }}</span>
            </div>
            <div class="info-item">
              <label>物流单号</label>
              <span>{{ docData.baseLogisticsNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>联系方式</label>
              <span>{{ docData.baseLogisticsContact || "--" }}</span>
            </div>
            <div class="info-item info-item--full">
              <label>备注</label>
              <span>{{ docData.remark || "--" }}</span>
            </div>
          </div>
        </div>

        <div class="delivery-card delivery-card--detail">
          <div class="delivery-card__head delivery-card__head--plain">
            <span class="delivery-card__title">发货明细</span>
          </div>
          <el-table
            :data="detailList"
            border
            size="small"
            class="detail-table"
          >
            <el-table-column type="index" label="序号" width="55" align="center" />
            <el-table-column label="产品编号" min-width="120" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.baseMaterialNumber || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="产品名称" min-width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.baseMaterialName || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="规格" min-width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ formatSpecLabel(row) }}
              </template>
            </el-table-column>
            <el-table-column label="本次出货" min-width="120">
              <template slot-scope="{ row }">
                {{ formatQty(row.baseOutsourcingFinishedQuantity) }}
              </template>
            </el-table-column>
            <el-table-column label="单位" min-width="70">
              <template slot-scope="{ row }">
                {{ row.baseMaterialUnitName || "--" }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="docData.statusCheck == 1" class="checkImg">
          <img src="@/assets/images/examine.png" alt="已审核" />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {
  processCoopDelivery_view,
  processCoopDelivery_auditByGlobal,
  processCoopDelivery_outWarehouse,
  processCoopDelivery_cancellationOutWarehouse,
} from "@/api/myController/outsourcing";
import finishAdd from "@/views/outsourcingProcesses/components/finish_add.vue";
import {
  formatSpecLabel,
  formatQty,
  applyProcessDeliveryFields,
  createProcessDeliveryForm,
  buildProcessAuditPayload,
  buildProcessOutWarehousePayload,
  resolveProcessAuditGlobalId,
} from "@/utils/outsourcingProcessFinishDelivery";
export default {
  components: { finishAdd },
  props: {
    routeQuery: {
      default: () => ({}),
    },
  },
  data() {
    return {
      homeLoading: false,
      cancelAuditLoading: false,
      outWarehouseLoading: false,
      cancelOutWarehouseLoading: false,
      docData: {},
      processCoopDelivery_view,
      detailList: [],
    };
  },
  computed: {
    showCancelAuditButton() {
      return (
        Number(this.docData.statusCheck) === 1 &&
        Number(this.docData.statusOutwarehouse) !== 1
      );
    },
    showOutWarehouseButton() {
      return (
        Number(this.docData.statusCheck) === 1 &&
        Number(this.docData.statusOutwarehouse) === 0
      );
    },
    showCancelOutWarehouseButton() {
      return Number(this.docData.statusOutwarehouse) === 1;
    },
    displayExpectedDate() {
      const date = this.docData.baseExpectedArrivalDate || "";
      return date ? String(date).split(" ")[0] : "--";
    },
  },
  created() {
    this.getList();
  },
  methods: {
    formatSpecLabel,
    formatQty,
    getList() {
      const id = this.routeQuery.processCoopDeliveryId;
      if (!id) {
        this.$message.error("缺少发货单 ID");
        return;
      }
      this.homeLoading = true;
      processCoopDelivery_view({ processCoopDeliveryId: id })
        .then((res) => {
          const raw = res.data.data || {};
          this.docData = applyProcessDeliveryFields(
            createProcessDeliveryForm(),
            raw
          );
          this.detailList = [this.docData];
        })
        .finally(() => {
          this.homeLoading = false;
        });
    },
    backHome() {
      this.$emit("backHome");
    },
    handleCancelAudit() {
      const globalId = resolveProcessAuditGlobalId(this.docData);
      this.$confirm("确认取消审核该发货单？", "提示", { type: "warning" })
        .then(async () => {
          this.cancelAuditLoading = true;
          try {
            await processCoopDelivery_auditByGlobal(
              buildProcessAuditPayload(globalId, 2)
            );
            this.$message.success("已取消审核");
            this.getList();
          } finally {
            this.cancelAuditLoading = false;
          }
        })
        .catch(() => {});
    },
    handleOutWarehouse() {
      const docId = this.docData.processCoopDeliveryId;
      this.$confirm("确认对该发货单执行出库？", "提示", { type: "warning" })
        .then(async () => {
          this.outWarehouseLoading = true;
          try {
            await processCoopDelivery_outWarehouse(
              buildProcessOutWarehousePayload(docId)
            );
            this.$message.success("出库成功");
            this.getList();
          } finally {
            this.outWarehouseLoading = false;
          }
        })
        .catch(() => {});
    },
    handleCancelOutWarehouse() {
      const docId = this.docData.processCoopDeliveryId;
      this.$confirm("确认撤销该发货单的出库？", "提示", { type: "warning" })
        .then(async () => {
          this.cancelOutWarehouseLoading = true;
          try {
            await processCoopDelivery_cancellationOutWarehouse(
              buildProcessOutWarehousePayload(docId)
            );
            this.$message.success("已撤销出库");
            this.getList();
          } finally {
            this.cancelOutWarehouseLoading = false;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.delivery-page {
  position: relative;
  min-height: calc(100vh - 130px);
  background: #fff;
}
.page-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-header__title {
  margin: 0;
  font-size: 22px;
  color: #1476c3;
  font-weight: 600;
}
.page-header__actions {
  display: flex;
  flex-wrap: wrap;
}
.delivery-card {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
}
.delivery-card__head {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 12px 20px;
  background: linear-gradient(90deg, #eef6ff 0%, #f9fcff 100%);
  border-bottom: 1px solid #e4e7ed;
}
.delivery-card__head--plain {
  background: #fff;
}
.delivery-card__label {
  margin-right: 10px;
  color: #606266;
}
.delivery-card__title {
  font-weight: 600;
  color: #303133;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px 24px;
  padding: 20px;
}
.info-item label {
  display: block;
  margin-bottom: 6px;
  color: #606266;
  font-size: 13px;
}
.info-item span {
  display: block;
  min-height: 34px;
  line-height: 34px;
  padding: 0 12px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  color: #303133;
  font-size: 13px;
}
.info-item--full {
  grid-column: 1 / -1;
}
.detail-table {
  margin: 16px 20px;
  width: calc(100% - 40px);
}
.checkImg {
  position: absolute;
  right: 48px;
  top: 58px;
  width: 130px;
  height: 130px;
  z-index: 2;
  pointer-events: none;
  opacity: 0.9;
  transform: rotate(15deg);
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
